export { ThumbUp as default } from './ThumbUp';
